import axios from '../config/axiosConfig';

const API_URL = '/web-reports';

const webTestReportService = {
  // WSTG Coverage
  getWstgCoverage(webTargetId) {
    return axios.get(`${API_URL}/wstg/${webTargetId}`).then(r => r.data);
  },

  getWstgGapAnalysis(webTargetId) {
    return axios.get(`${API_URL}/wstg/${webTargetId}/gaps`).then(r => r.data);
  },

  updateWstgTestStatus(webTargetId, testId, status, notes) {
    return axios.put(`${API_URL}/wstg/${webTargetId}/test/${testId}`, { status, notes }).then(r => r.data);
  },

  // WAF Effectiveness
  getWafReport(webTargetId) {
    return axios.get(`${API_URL}/waf/${webTargetId}`).then(r => r.data);
  },

  // AuthZ Report
  getAuthzReport(scenarioId) {
    return axios.get(`${API_URL}/authz/${scenarioId}`).then(r => r.data);
  },

  // Vulnerability Report
  getVulnerabilityReport(webTargetId) {
    return axios.get(`${API_URL}/vulnerabilities/${webTargetId}`).then(r => r.data);
  },

  // Before/After Comparison
  compareRuns(scenarioId1, scenarioId2) {
    return axios.post(`${API_URL}/compare`, { scenarioId1, scenarioId2 }).then(r => r.data);
  },

  // Regression Tests
  getRegressionTests(webTargetId) {
    return axios.get(`${API_URL}/regression/${webTargetId}`).then(r => r.data);
  },

  createRegressionTest(scenarioId, name) {
    return axios.post(`${API_URL}/regression/create`, { scenarioId, name }).then(r => r.data);
  },

  runRegressionTest(testId) {
    return axios.post(`${API_URL}/regression/run/${testId}`).then(r => r.data);
  },

  getRegressionStatus(testId) {
    return axios.get(`${API_URL}/regression/status/${testId}`).then(r => r.data);
  },

  getRegressionResults(testId) {
    return axios.get(`${API_URL}/regression/results/${testId}`).then(r => r.data);
  },

  compareRegressionRuns(scenarioId1, scenarioId2) {
    return axios.post(`${API_URL}/regression/compare`, { scenarioId1, scenarioId2 }).then(r => r.data);
  },

  // HAR Import
  importHar(webTargetId, harData, options = {}) {
    return axios.post(`${API_URL}/import-har/${webTargetId}`, { harData, options }).then(r => r.data);
  },

  // Blue Team Scenarios
  getBlueTeamScenarios(webTargetId) {
    return axios.get(`${API_URL}/blue-team/${webTargetId}`).then(r => r.data);
  },

  createBlueTeamScenario(data) {
    return axios.post(`${API_URL}/blue-team`, data).then(r => r.data);
  },

  deleteBlueTeamScenario(id) {
    return axios.delete(`${API_URL}/blue-team/${id}`).then(r => r.data);
  }
};

export default webTestReportService;
